<template>
  <v-app>
    <v-toolbar class="blue"
               height="58"
               app
               clipped-left>
      <!-- https://vuetifyjs.com/en/framework/colors -->
      <router-link tag="span" to="/" class="noselect">
        <v-toolbar-title class="headline text-uppercase">
          <span>HawkSoft</span>
          <span class="font-weight-light">Status</span>
        </v-toolbar-title>
      </router-link>
       <v-spacer />
       <v-flex
              v-if="!$vuetify.breakpoint.xs"
              pt-1
              xs4
              style="max-width:250px">
        <div class="display-1 white--text">{{ environment }}</div>
      </v-flex>
    </v-toolbar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<style>
.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently supported by Chrome and Opera */
}
</style>

<script>
export default {
  name: 'App',
  data () {
    return {
      drawer: false,
      environmentsError: null
    };
  },
  computed: {
    environment () {
      return localStorage.getItem('environment');
    },
    environments () {
      return JSON.parse(localStorage.getItem('environments'));
    }
  }
};
</script>
